export default __webpack_public_path__ + "static/media/Iron_2_Rank.268a1081.png";